<template>
  <div class="modal right fade" :id="objectModalName.riskAnalysis" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.riskAnalysis)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.riskAnalysis)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">Risikobewertung
                  <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
                </p>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <accordion :oneOpen="false">
                <template v-slot:content>
                  <accordion-item title="Beschreibung / Erklärungen">
                    <template v-slot:content>
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <p>Risikomaßstab:</p>
                              <ul style="font-size: 0.85rem;">
                                <li>0 - 3 = Normal - Kein rechtserhebliches Risiko (Grundrisiko) → keine Aktion erforderlich</li>
                                <li>4 - 6= Hoch - das allgemein vorhandene Risiko (Grundrisiko)  übersteigend → Das Risiko muss betrachtet und bewertet werden.</li>
                                <li>7 - 9 = Sehr hoch → Das Risiko muss behandelt (Maßnahme) oder von der Aufsichtsbehörde geprüft werden.</li>
                              </ul>
                            <p>Der daraus abgeleitete Schutzbedarf der personenbezogenen Daten wird in die Schutzklassen eingeteilt:</p>
                            <label class="col-form-label" style="font-size: 0.85rem;">• Normal • Hoch • Sehr hoch</label>
                          </div>
                        </div>
                      </div>
                    </template>
                  </accordion-item>
                  <accordion-item title="Durchführung" :isActive="true">
                    <template v-slot:content>
                      <div class="row">
                <div class="col">
                  <h4 class="dkl-h4">Allgemein</h4>

                  <div class="form-group row">
                    <div class="col-6">
                      <label class="col-form-label">Verarbeitungstätigkeit<span class="text-danger">*</span></label>
                      <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis.vt_detail.name}}</p>
                      <div v-show="!riskAnalysis.id || edit">
                        <select class="form-control select select-vt select-single" v-model="riskAnalysis.vt" v-select2>
                          <option v-for="vt in vts" :key="vt.id" :value="vt.id">{{vt.name}}</option>
                        </select>
                      </div>
                      <span class="error-message text-danger" v-show="v$.riskAnalysis.vt.$errors.length>0">{{ $t('required_field') }}</span>
                    </div>
                    <div class="col-6">
                      <label class="col-form-label">Grund der Risikobewertung</label>
                      <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis.reason}}</p>
                      <textarea class="form-control" v-show="!riskAnalysis.id || edit" v-model="riskAnalysis.reason" placeholder="Grund der Risikobewertung" autocomplete="off"></textarea>
                    </div>
                  </div> <!-- end row -->

                  <h4 class="dkl-h4" v-show="!detailedAnalysis">Einfache Bewertung</h4>
                  <div v-show="!detailedAnalysis" class="mb-2">
                    <div class="form-group row">
                      <div class="col-6">
                        <label class="col-form-label">{{verboseNames.bsi_basis}}</label>
                        <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis.bsi_basis}}</p>
                      </div>
                      <div class="col-6">
                        <label class="col-form-label">{{verboseNames.dsgvo_basis}}</label>
                        <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis.dsgvo_basis}}</p>
                      </div>
                    </div>
                    <div class="col-12" v-if="!riskAnalysis.id || edit">
                      <div><a class="editor-simple-risk btn btn-outline-info" :data-vt-id="riskAnalysis.vt" href="#" @click.prevent="$emit('simpleRiskAnalysis', riskAnalysis.vt)">Einfache Risikobewertung durchführen</a></div>
                    </div>
                  </div>

                  <h4 class="dkl-h4">Eintrittswahrscheinlichkeit (IT Sicherheit)</h4>
                  <div class="form-group" style="padding-bottom: 5px; border-bottom: 1px solid gray;">
                    <p>Bewertung für einzelne Kriterium</p>
                    <label class="col-form-label">0 = nicht relevant, 1 = unwahrscheinlich, 2 = wahrscheinlich, 3 = sehr wahrscheinlich</label>
                  </div>

                  <div>
                    <div class="form-group row" v-for="(bsiPair, index) in pairedBSIGroups" :key="`bsi_${index}`">
                      <div class="col-6" v-for="(item, itemIndex) in bsiPair" :key="`bsiItem_${itemIndex}`">
                        <label class="col-form-label">{{verboseNames[item]}}
                          <span v-if="item in helpText">
                            <a :href="helpText[item]" target="_blank" v-if="isURL(helpText[item])"><i class="fa fa-question-circle "></i></a>
                            <a :href="helpText[item]" target="#" @click.prevent="showPopover($event, helpText[item])" v-if="!isURL(helpText[item])"><i class="fa fa-question-circle dkl-popover-icon"></i></a>
                          </span>
                        </label>
                        <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis[item]}}</p>
                        <input type="number" class="form-control" v-show="!riskAnalysis.id || edit" v-model="riskAnalysis[item]" autocomplete="off">
                        <span class="error-message text-danger" v-show="v$.riskAnalysis[item].$errors.length>0">Wert von 0 - 3</span>
                      </div>
                    </div>
                  </div>

                  <h4 class="dkl-h4">AUSWIRKUNG (Datenschutz)</h4>
                  <div class="form-group" style="padding-bottom: 5px; border-bottom: 1px solid gray;">
                    <p>Bewertung für einzelne Kriterium</p>
                    <label class="col-form-label">0 =nicht anwendbar - keine Auswirkung, 1 = gering, 2 = hoch, 3 = sehr hoch (kritisch)</label>
                  </div>

                  <div>
                    <div class="form-group row" v-for="(bsiDSGVO, index) in pairedDSGVOGroups" :key="`dsgvo_${index}`">
                      <div class="col-6" v-for="(item, itemIndex) in bsiDSGVO" :key="`dsgvoItem_${itemIndex}`">
                        <label class="col-form-label">{{verboseNames[item]}}
                          <span v-if="item in helpText">
                            <a :href="helpText[item]" target="_blank" v-if="isURL(helpText[item])"><i class="fa fa-question-circle"></i></a>
                            <a :href="helpText[item]" target="#" @click.prevent="showPopover($event, helpText[item])" v-if="!isURL(helpText[item])"><i class="fa fa-question-circle dkl-popover-icon"></i></a>
                          </span>
                        </label>
                        <p class="mt-1 fs-14" v-if="riskAnalysis.id && !edit">{{riskAnalysis[item]}}</p>
                        <input type="number" class="form-control" v-show="!riskAnalysis.id || edit" v-model="riskAnalysis[item]" autocomplete="off">
                        <span class="error-message text-danger" v-show="v$.riskAnalysis[item].$errors.length>0">Wert von 0 - 3</span>
                      </div>
                    </div>
                  </div>
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
                    </template>
                  </accordion-item>
                </template>
              </accordion>
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="dkl-popover" ref="riskanalysisPopover"><p>{{popoverContent}}</p></div>
        <div class="modal-footer">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveRiskAnalysis">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="border-0 btn btn-warning btn-gradient-warning btn-rounded" @click.prevent="saveRiskAnalysisNoExit">Speichern und weiter bearbeiten</button>
          <button type="button" class="btn btn-secondary btn-rounded close-component" @click="closeWarning('#'+objectModalName.riskAnalysis)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import service from '@/utils/request.js';
import { useVuelidate } from '@vuelidate/core';
import { required, maxValue } from '@vuelidate/validators';
import { Button } from 'vant';
import {closeWarning, ajaxErrorMessage, fetchVTs, initSelect2, isURL} from '@/utils/index.js';
import {objectModalName, newRiskAnalysis} from "@/utils/enums";
import accordion from "@/components/component/AccordionComponent.vue";
import accordionItem from "@/components/component/AccordionItemComponent.vue";

  export default {
      name: "DKLRiskAnalysis",
      components: {
        accordionItem,
        accordion,
        'van-button': Button,
      },
      props: {
        riskAnalysis: {
          type: Object,
          default: () => newRiskAnalysis
        },
        bsiGroups: {
          type: Array,
          default: () => []
        },
        dsgvoGroups: {
          type: Array,
          default: () => []
        },
        verboseNames: {
          type: Object,
          default: () => {}
        },
        helpText: {
          type: Object,
          default: () => {}
        },
        detailedAnalysis: {
          type: Boolean,
          default: false
        }
      },
      data() {
        return {
          newComment: '',
          objectModalName: objectModalName,
          surveyBody: false,
          popoverContent: '',
        }
      },
      validations() {
        let itemsValiation = {}
        this.bsiGroups.forEach(item => itemsValiation[item] = this.validateMaxValue())
        this.dsgvoGroups.forEach(item => itemsValiation[item] = this.validateMaxValue())
        return {
          riskAnalysis: {
            vt: {required, $lazy: true},
            ...itemsValiation
          },
        }
      },
      setup() {
        return {
          v$: useVuelidate()
        }
      },
      watch:{
        incident: {
          handler: function (newValue, oldVal) {
            if (!this.modalDirty) this.setModalDirty(true)
          },
          deep: true
        }
      },
      computed: {
        ...mapState({
          user: state => state.user,
          vts: state => state.data.vts,
          account: state => state.account,
          edit: state => state.app.edit,
          modalDirty: state => state.app.modalDirty,
        }),
        pairedBSIGroups() {
          let result = []
          for (let i=0; i<this.bsiGroups.length; i+=2) {
            result.push(this.bsiGroups.slice(i, i+2))
          }
          return result
        },
        pairedDSGVOGroups() {
          let result = []
          for (let i=0; i<this.dsgvoGroups.length; i+=2) {
            result.push(this.dsgvoGroups.slice(i, i+2))
          }
          return result
        },
        bsiArray() {
          return this.bsiGroups.map(item => this.riskAnalysis[item])
        },
        dsgvoArray() {
          return this.dsgvoGroups.map(item => this.riskAnalysis[item])
        }
      },
      mounted() {
        $(`#${objectModalName.riskAnalysis}`).on('hidden.bs.modal', () => {
          this.setEdit(false)
          $('#' + objectModalName.riskAnalysis + ' .modal-footer button.close-component').text('Abbrechen')
        });
        fetchVTs(this.account.accountid)
        initSelect2()
        $(`#${objectModalName.riskAnalysis}`).on('shown.bs.modal', () => {
          $(`#${objectModalName.riskAnalysis} .select-vt`).val(this.riskAnalysis.vt).trigger('change')
        })
      },
      beforeDestroy() {
        $(`#${objectModalName.riskAnalysis}`).off('hidden.bs.modal')
        $(`#${objectModalName.riskAnalysis}`).off('shown.bs.modal')
      },
      methods: {
        isURL,
        closeWarning,
        ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
        validateMaxValue() {
          return {
            required,
            maxValue: maxValue(3)
          }
        },
        showPopover(e, helpText) {
          const popover = this.$refs.riskanalysisPopover
          if (window.getComputedStyle(popover).display == 'none') {
            popover.style.right = '50px'
            popover.style.top = `${e.clientY + 50}px`
            popover.style.width = '80%'
            this.popoverContent = helpText
            popover.style.display = 'block'
          } else {
            popover.style.display = 'none'
          }
        },
        maxValue(riskArray) {
          const intArray = riskArray.map(item => parseInt(item))
          return Math.max(...intArray)
        },
        async saveRiskAnalysis() {
          await this.saveRiskAnalysisNoExit()
          $('#' + objectModalName.riskAnalysis).modal('hide')
        },
        async saveRiskAnalysisNoExit() {
          const isValid = await this.v$.riskAnalysis.$validate()
          if (!isValid) {
            this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
            return false
          }
          const newRiskAnalysis = this.riskAnalysis.id == null ? true : false
          let url = 'todos/v1/create_risk_analysis/'
          if (!newRiskAnalysis) url = `todos/v1/update_risk_analysis/${this.riskAnalysis.id}/`
          this.riskAnalysis.modified_by = this.user.username
          service.request({
            url: url,
            method: 'POST',
            responseType: 'json',
            data: this.riskAnalysis
          }).then((response) => {
            this.setModalDirty(false)
            this.v$.$reset()
            this.$emit('riskAnalysisUpdated', response.data)
            $('#' + objectModalName.riskAnalysis + ' .modal-footer button.close-component').text('Schließen')
            this.$vToastify.success('Risikobewertung ist erfolgreich gespeichert!')
          }).catch(error => this.$vToastify.error(ajaxErrorMessage(error)))
        },
      }
    }
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}
</style>
